import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { useNavigate } from "react-router-dom"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"

export default function CQ9KingOfBetting() {
  const navigate = useNavigate()
  const data = promotionsData.find(
    (promo) => promo.title === "CQ9 King of Betting"
  )
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  //If the promo page is expired - throws error
  useEffect(() => {
    if (!data) {
      navigate("/not-found")
    }
  }, [data, navigate])

  if (!data) return null

  return (
    <>
      <Helmet>
        <meta charset="utf-8" />
        <title>CQ9 King of Betting</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a href="/promotion/"> Promotions </a> / <span>{data.title}</span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH ${data.title}`}
              />
            </div>
            <div className="promotion-tnc-content">
              <div className="promotion-tnc-info">
                <div
                  className={`promotion-indication-message ${data.promotionMessage.class}`}
                >
                  {data.promotionMessage.text}
                </div>
                <h1>CQ9 King of Betting</h1>
                <h2>Total prize soars to ₱8,000,000</h2>
                <div className="promotion-tnc-period">
                  <strong> Event Period: </strong>
                  <span> February 05 (12PM) - March 05 (12PM)</span>
                </div>
              </div>
              <div className="promotion-tnc-mechanic-content">
                <strong> Mechanics: </strong>
                <ol>
                  <li>
                    During the event period, you can participate in the CQ9 The
                    King of betting by playing the games from [CQ9 Legend
                    Electronics]!
                  </li>
                  <li>
                    As long as you place a bet on games of CQ9, those who have
                    accumulated the top 2,000 ranking of total bets in the
                    "week" can get a weekly event bonus, up to 708,888(PHP)！
                  </li>
                  <li>
                    During the event period, as long as you are on the
                    leaderboard, we will give out 2,000 prizes every week!
                  </li>
                </ol>
                <div className="table-wrapper">
                  <table
                    className="promotion-tnc-table"
                    style={{ minWidth: "0" }}
                  >
                    <thead>
                      <th colSpan={2}>🏆 The King of Betting</th>
                    </thead>
                    <tbody>
                      <tr>
                        <td> 1 </td>
                        <td> ₱708,888</td>
                      </tr>
                      <tr>
                        <td> 2 </td>
                        <td> ₱228,888</td>
                      </tr>
                      <tr>
                        <td> 3 </td>
                        <td> ₱72,888</td>
                      </tr>
                      <tr>
                        <td> 4-5 </td>
                        <td> ₱22,888</td>
                      </tr>
                      <tr>
                        <td> 6-10 </td>
                        <td> ₱7,288</td>
                      </tr>
                      <tr>
                        <td> 11-50 </td>
                        <td> ₱2,288 </td>
                      </tr>
                      <tr>
                        <td> 51-100 </td>
                        <td> ₱1,488</td>
                      </tr>
                      <tr>
                        <td> 101-500 </td>
                        <td> ₱708 </td>
                      </tr>
                      <tr>
                        <td> 501-1000 </td>
                        <td> ₱468 </td>
                      </tr>
                      <tr>
                        <td> 1001-2000 </td>
                        <td> ₱228 </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="promotion-tnc-cta">
                  <a
                    className="promotion-cta-btn"
                    href="https://betking.jiamengweiquan.com/newyearph"
                    target="_blank"
                  >
                    View Full T&C
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
